<template>
  <FlotoCrudContainer
    ref="list"
    as-table
    prepend-new-item
    :fetch-fn="fetchUninstall"
    :delete-fn="updateUninstall"
    :columns="tableColumns"
  >
    <template v-slot:add-controls="{ create, refreshList }">
      <MRow :gutter="0" class="items-center">
        <MCol :size="12" class="flex items-center mb-4">
          <div class="flex-1">
            <FlotoSearchBar
              ref="searchBar"
              :allow-keywords="false"
              :allow-save-search="false"
              :persist-criteria="false"
              :available-asset-type="
                getAssetTypeSystemName[$constants.ASSET_HARDWARE]
              "
              :module-name="$constants.SOFTWARE_UNINSTALLTION_TASK"
              @change="applyCriteria($event, refreshList)"
            />
          </div>
        </MCol>
      </MRow>
    </template>
    <template v-slot:assetName="{ item }">
      <td class="text-ellipsis">
        <ResourceListTitle
          :name="item.assetName"
          open-in-new-tab
          :link="
            $modules.getModuleRoute('asset', 'view', {
              params: {
                id: item.assetId,
                assetType: $constants.ASSET_HARDWARE,
              },
            })
          "
        />
      </td>
    </template>
    <template v-slot:assetTypeId="{ item }">
      <td class="text-ellipsis">
        <div class="flex">
          <AssetTypeIcon
            :asset-type-id="item.assetTypeId"
            size="md"
            class="mr-2"
          />
          <FlotoAssetTypePicker
            :value="item.assetTypeId"
            disabled
            placeholder="---"
          />
        </div>
      </td>
    </template>
    <template v-slot:result="{ item }">
      <td class="text-ellipsis">
        {{ item.result ? item.result : '---' }}
      </td>
    </template>
    <template v-slot:assignedUserIds="{ item }">
      <td class="text-ellipsis">
        <span v-if="(item.assignedUserIds || []).length === 0">---</span>
        <span v-else>
          <FlotoUserDrawer
            v-for="userId in item.assignedUserIds"
            :key="userId"
            :user-id="userId"
        /></span>
      </td>
    </template>
    <template v-slot:createdTime="{ item }">
      <td class="text-ellipsis">
        <span v-if="item.createdTime === 0">---</span>
        <span v-else>{{ item.createdTime | datetime }}</span>
      </td>
    </template>
    <template v-slot:uninstallationDate="{ item }">
      <td class="text-ellipsis">
        <span v-if="item.uninstallationDate === 0">---</span>
        <span v-else>{{ item.uninstallationDate | datetime }}</span>
      </td>
    </template>
    <template v-slot:unistalltationTimeBy="{ item }">
      <td class="text-ellipsis">
        <span v-if="item.unistalltationTimeBy === 0">---</span>
        <span v-else>{{ item.unistalltationTimeBy | datetime }}</span>
      </td>
    </template>
    <template v-slot:status="{ item }">
      <td class="text-ellipsis">
        {{
          item.status
            ? (
                softwareUninstallationTaskStatusOptions.find(
                  (i) => i.key === item.status
                ) || {}
              ).text
            : ''
        }}
      </td>
    </template>
    <template v-slot:actions="{ item, remove }">
      <td class="text-ellipsis">
        <FlotoDeleteBtn
          :class="{ invisible: item.status !== 'detected' }"
          :message="
            $t('confirm_cancel', {
              resource: `${$tc('uninstall')} ${$tc('software')}`,
            })
          "
          @confirm="remove"
        >
          <MTooltip>
            <template v-slot:trigger>
              <a>
                <MIcon name="times" class="action-menu-icon" />
              </a>
            </template>
            {{ $tc('cancel') }}
          </MTooltip>
        </FlotoDeleteBtn>
      </td>
    </template>
  </FlotoCrudContainer>
</template>
<script>
import { getAssetTypeSystemName } from '@modules/asset/helpers/asset-type'
import AssetTypeIcon from '@components/custom-icon/asset-type-icon'
import ResourceListTitle from '@components/resource/resource-list-title'
import {
  fetchSoftwareUninstallTaskApi,
  updateUninstallTaskApi,
} from '@modules/asset/asset-api'
import { softwareUninstallationTaskStatusOptions } from '../helpers/option-map'
export default {
  name: 'UninstallationTab',
  components: {
    ResourceListTitle,
    AssetTypeIcon,
  },
  props: {
    resourceId: { type: Number, required: true },
  },
  data() {
    this.getAssetTypeSystemName = getAssetTypeSystemName
    this.softwareUninstallationTaskStatusOptions =
      softwareUninstallationTaskStatusOptions()
    return {
      tableColumns: [
        {
          name: `${this.$tc('task')} ${this.$t('id')}`,
          key: 'name',
          width: '100px',
          minWidth: '100px',
        },
        {
          name: `${this.$tc('asset')} ${this.$t('id')}`,
          key: 'assetName',
          width: '100px',
          minWidth: '100px',
        },
        {
          name: `${this.$tc('asset')} ${this.$t('type')}`,
          key: 'assetTypeId',
          width: '150px',
          minWidth: '150px',
        },
        {
          name: `${this.$tc('used_by')}`,
          key: 'assignedUserIds',
          width: '100px',
          minWidth: '100px',
        },
        {
          name: `${this.$tc('detection_date')}`,
          key: 'createdTime',
        },
        {
          name: `${this.$tc('uninstallation')} ${this.$tc('date')}`,
          key: 'uninstallationDate',
        },
        {
          name: `${this.$tc('uninstallation')} ${this.$tc(
            'only_time'
          )} ${this.$tc('by')}`,
          key: 'unistalltationTimeBy',
        },
        {
          name: `${this.$tc('status')}`,
          key: 'status',
          width: '100px',
          minWidth: '100px',
        },
        {
          name: `${this.$tc('result')}`,
          key: 'result',
          width: '100px',
          minWidth: '100px',
        },
        {
          name: `${this.$tc('action', 2)}`,
          key: 'actions',
          width: '100px',
          minWidth: '100px',
        },
      ],
      searchCriterias: {
        quals: [],
      },
    }
  },
  methods: {
    applyCriteria(searchCriteria, refreshList) {
      this.searchCriterias = searchCriteria
      refreshList()
    },
    fetchUninstall(limit, offset) {
      return fetchSoftwareUninstallTaskApi(
        this.resourceId,
        this.searchCriterias,
        limit,
        offset
      )
    },
    refresh() {
      this.$refs.list.refresh()
    },
    updateUninstall(item) {
      return updateUninstallTaskApi({
        id: item.id,
        status: 'cancelled',
      }).then(() => this.refresh())
    },
  },
}
</script>
